export default "__VITE_ASSET__BRMzfj2W__"